
import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'app-homepage-widget',
  standalone: true,
  imports: [ChartModule, TranslatePipe],
  templateUrl: './homepage-widget.component.html',
  styleUrl: './homepage-widget.component.scss',
})
export class HomepageWidgetComponent {
  @Input() title: string = 'homepage-widget';
  @Input() legend: string = 'homepage-widget works!';
  @Input() data: any;
  @Input() options: any;
  @Input() isChart: boolean = false;
  @Input() isLoading: boolean = true;
  @Input() errorMessage: string | null = null;
}
